<template>
  <div>
    <eSimPlusWeb v-if="!isMobile"></eSimPlusWeb>
    <eSimPlusMobile v-if="isMobile"></eSimPlusMobile>
  </div>
</template>
<script>
import eSimPlusWeb from "./Esim-plus-web.vue";
import eSimPlusMobile from "./Esim-plus-mobile.vue";
export default {
  name: "contact",
  data() {
    return {
      isMobile: true,
    };
  },
  components: {
    eSimPlusWeb,
    eSimPlusMobile,
  },
  mounted() {
    const detectDeviceType = () =>
      /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
        ? "Mobile"
        : "Desktop";
    this.isMobile = detectDeviceType() === "Mobile";
  },
  methods: {},
};
</script>
<style lang="less">
</style>
